import { CssBaseline } from '@mui/material';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { store } from '@/domain/store';

import { pdfRouter } from './pages/pdf/PdfRouter';

export function PdfRoot() {
  dayjs.extend(isSameOrBefore);
  dayjs.extend(isSameOrAfter);

  return (
    <ReduxProvider store={store}>
      <CssBaseline />
      <RouterProvider router={pdfRouter} />
    </ReduxProvider>
  );
}
